<template>
  <div id="create-data-page" v-if="site">
    <h2 class="intro-y text-lg font-medium mt-10">
      新增{{ site.name }}的職能名稱
    </h2>

    <role-form v-if="checkPermission(permissions, 'system.role.create')" :site="site"></role-form>
    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['auth', 'permissions'],
  data() {
    return {
      mounted: false,
      site: null
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    permissions() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      await this.loadSite()

      if (this.permissions) {
        setTimeout(() => {
          this.mounted = true
        }, 500)
      }
    },
    async loadSite() {
      this.site = await this.getSite(this.$route.params.siteId)
    }
  }
}
</script>

<style lang="scss" scoped></style>
